import {useEffect, useRef} from 'react'
import useScroll from '../../assets/hooks/useScroll'
import {withLanguage, withDictionary} from '../../assets/js/contexts'
import './about-craft-beer.scss'
import config from '../../config'
import {useLang} from "../../helpers/language";

const AboutCraftBeer = ({dictionary}) => {
    const scroll = useScroll()
    const image = useRef()
    const {lang} = useLang();
    useEffect(() => {
        if (! image.current) {
            return
        }

        const end = image.current.offsetTop
        const speed = 1.5
        image.current.style.transform = `scale(1.5) translateX(${
            (scroll * 100 / end * speed) - 110
        }%)`
    }, [image, scroll])

    return (
        <div id="about-craft-beer">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-10">
                        <h2>{
                            config.pages.home.aboutCraft.title[lang]
                        }</h2>
                        <p> {
                            config.pages.home.aboutCraft.desc[lang]
                        } </p>
                    </div>
                </div>
            </div>
            <div className="animation-wrapper">
                <img src="/static/images/craft-independent-small.svg" width="100%" data-content="craft-independent-small"
                    ref={image}
                    alt=""/>
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <img src="/static/images/brewery-image.jpg" width="100%" data-content="brewery-image" alt=""/>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withLanguage(withDictionary(AboutCraftBeer))
